import React from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { WeaTagGroup } from "ecCom";

@observer
export default class TagGroupItem extends React.PureComponent {
  onChange = (datas, value) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(value, datas);
    if (typeof onChange === "function") {
      onChange(itemKey, [value, datas]);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaTagGroup
        ecId={`${this.props.ecId}_WeaTagGroup@bepu1s`}
        {...bindObj.bind()}
        onChange={this.onChange}
        {...c}
        label={""}
        {...c.otherParams}
        datas={toJS(bindObj.valueSpan || [])}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/TagGroupItem.js